;(function () {
  'use strict'

  function init() {
    const videoBanners = document.querySelectorAll('.video-banner-clickable')
    videoBanners.forEach((banner) => {
      handleClickableBanner(banner)
    })
  }

  function handleClickableBanner(banner) {
    const clickableUrl = banner.dataset.clickableUrl
    if (!clickableUrl) return

    // Make banner clickable
    banner.style.cursor = 'pointer'

    // Prevent clicks on interactive elements from triggering banner click
    const interactiveElements = banner.querySelectorAll(
      'a, button, input, select, textarea, video',
    )

    interactiveElements.forEach((el) => {
      el.addEventListener('click', (e) => {
        e.stopPropagation()
      })
    })

    // Add click handler to banner
    banner.addEventListener('click', (e) => {
      // Only navigate if not clicking on interactive elements
      const target = e.target
      if (
        !target.closest('a') &&
        !target.closest('button') &&
        !target.closest('input') &&
        !target.closest('select') &&
        !target.closest('textarea') &&
        !target.closest('video')
      ) {
        window.location.href = clickableUrl
      }
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }

  // Handle Shopify theme editor
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target
    const videoBanners = section.querySelectorAll('.video-banner-clickable')
    videoBanners.forEach((banner) => {
      handleClickableBanner(banner)
    })
  })
})()
